import Vue from 'vue'
import Vuex from 'vuex'
import {proposalService} from '@/utils/api.js';
import {kbdpAlert} from "@/utils/util.js";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  
	proposal: {
    frontPage: {},
    toc: { pages: [] },
    resume: {},
    comparable: {},
    approach: {},
    lastPage: {},
    customPages: [],
    sectionOrder: []
    },
	completeProposalId:null,
	opportunityId:null,
    userData: null,
    projects: { data: [], pagination: {} },
    members: { data: [], pagination: {} },
    memberProjects: {}, // { memberId: { data: [], pagination: {} } }
    marketSegments: { data: [], pagination: {} },
    selectedOpportunity: [],
    aiResponses: {}, // { type-id: response } e.g., { 'member-123': 'AI bio text', 'project-456': 'AI description' }
    questionsResponse: "",
    loading: {
      userData: false,
      aiGenerateById: {}, // { type-id: boolean } e.g., { 'member-123': true, 'project-456': false }
      project: false,
      member: false,
      aiGenerate: false,
      opportunity: false,
      marketSegment: false,
      memberProjects: {}, // { memberId: false }
      spellCheck: false,
      isExporting: false,
	  proposal:false,
    },
  },

  mutations: {
    SET_LOADING(state, status) {
      state.loading = { ...state.loading, ...status }
    },

    SET_SPELL_CHECK_LOADING(state, status) {
      state.loading.spellCheck = status;
    },

    SET_PROJECTS(state, payload) {
		console.log('In SET_PROJECTS payload');
		console.log(payload);
      const { data, pagination, page, memberId } = payload;

      if (memberId) {
        if (!state.memberProjects[memberId] || page === 1) {
          Vue.set(state.memberProjects, memberId, {
            data: data,
            pagination: pagination
          });
        } else {
          state.memberProjects[memberId].data = [...state.memberProjects[memberId].data, ...data];
          state.memberProjects[memberId].pagination = pagination;
        }
        return;
      }
      if (page === 1) {
        state.projects.data = data
        state.projects.pagination = pagination
      } else {
        state.projects.data = [...state.projects.data, ...data]
        state.projects.pagination = pagination
      }
    },

    SET_PROJECTS_LOADING(state, { memberId, status }) {
      if (memberId) {
        Vue.set(state.loading.memberProjects, memberId, status);
      } else {
        state.loading.project = status;
      }
    },

    SET_MEMBERS(state, payload) {
      const { data, pagination, page } = payload;
      if (page === 1) {
        state.members.data = data
        state.members.pagination = pagination
      } else {
        state.members.data = [...state.members.data, ...data]
        state.members.pagination = pagination
      }
    },

    SET_SELECTED_OPPORTUNITY(state, opportunity) {
      state.selectedOpportunity = opportunity
    },

    SET_MARKET_SEGMENTS(state, payload) {
      const { data, pagination,page } = payload;
      if (page === 1) {
        state.marketSegments.data = data
        state.marketSegments.pagination = pagination
      } else {
        state.marketSegments.data = [...state.marketSegments.data, ...data]
        state.marketSegments.pagination = pagination
      }
    },

    SET_AI_RESPONSE_BY_ID(state, { type, id, response }) {
      const key = `${type}-${id}`;
      Vue.set(state.aiResponses, key, response);
    },

    SET_AI_LOADING_BY_ID(state, { type, id, status }) {
      const key = `${type}-${id}`;
      Vue.set(state.loading.aiGenerateById, key, status);
    },

    SET_AI_RESPONSE(state, response) {
      state.questionsResponse = response;
    },

    SET_USER_DATA(state, response) {
      state.userData = response;
    },
	SET_COMPLETEPROPOSALID(state,completeProposalId) {
		//state.completeProposalId = completeProposalId;
		Vue.set(state, 'completeProposalId', completeProposalId)
	},	
	SET_PROPOSAL(state, proposal) {
	console.log('old', state.proposal)
	console.log('new', proposal)
    Vue.set(state, 'proposal', JSON.parse(JSON.stringify(proposal)));
	console.log('new1', state.proposal)
    },
	
	/*
	SET_PROPOSAL_FIELD(state, { path, value }) {
    // simple, explicit version without lodash:
    const segments = path.split('.');
    let target = state.proposal;
    for (let i = 0; i < segments.length - 1; i++) {
      const key = segments[i];
      if (!target[key]) Vue.set(target, key, {});
      target = target[key];
    }
    Vue.set(target, segments[segments.length - 1], value);
  }, */
  
  SET_PROPOSAL_FIELD(state, { path, value }) {
  const segments = path.split('.');
  let target = state.proposal;

  for (let i = 0; i < segments.length - 1; i++) {
    const key = segments[i];
    const nextKey = segments[i + 1];

    // Determine if the next segment is an array index
    const shouldBeArray = !isNaN(Number(nextKey));

    // Create missing segment
    if (target[key] === undefined || target[key] === null) {
      Vue.set(target, key, shouldBeArray ? [] : {});
    }

    // Fix incorrect type
    if (shouldBeArray && !Array.isArray(target[key])) {
      Vue.set(target, key, []);
    }
    if (!shouldBeArray && Array.isArray(target[key])) {
      Vue.set(target, key, {});
    }

    target = target[key];
  }

  Vue.set(target, segments[segments.length - 1], value);
},


  SET_PROPOSAL_FIELD_FOR_CUSTOM(state, { id, value }) {
    const list = state.proposal.customPages || [];
    const file = list.find(f => String(f.id) === String(id));
    if (file) {
      Vue.set(file, 'bannerTitle', value);
    }
  },
  RESET_PROPOSAL(state) {
	state.proposal = {
        pageOrientation: "portrait",
        frontPage: {
          template: "",
          style: null,
          projects: [],
          name: "",
          address: "",
          city: "",
          stateProvince: "",
          submissionDate: "",
          submittedBy: "",
          logo: "",
          clientLogo: "",
          compAddress: "",
          compCity: "",
          compStateProvince: "",
          compContactNo: "",
          compEmail: "",
          compWebsite: "",
          clientName: "",
        },
        toc: {
          title: "Table Of Contents",
          template: "",
          style: null,
          itemsPerPage: 24,
          pages: [],
          projects: []
        },
        orgChart: {
          title: "Project Org Chart",
          template: "",
          style: null,
          about: {
            title: "",
            description: "",
          },
          members: [],
          projects: [],
        },
        resume: {
          title: "Team Member Resume",
          blocks: [
            {
              id: "block_1",
              template: "",
              style: null,
              projectsPerPage: 6,
              members: [],
            }
          ]
        },
        comparable: {
          title: "Comparable Projects",
          blocks: [
            {
              id: "block_1",
              template: "",
              style: null,
              about: {
                title: "",
                description: "",
              },
              projects: [],
            }
          ]
        },
        approach: {
          title: "Approach",
          blocks: [
            {
              id: "block_1",
              template: "",
              style: null,
              projects: [],
              questions: [],
            }
          ]
        },
        lastPage: {
          template: "",
          style: null,
          projects: [],
          name: "",
          logo: "",
          address: "",
          city: "",
          stateProvince: "",
          contactNo: "",
          email: "",
          submittedBy: "",
          title: "",
          location: "",
        },
        customPages: [],
        sectionOrder: ['Front Page','Table of Contents','Org Chart', 'resume', 'comparable', 'approach','Last Page'],
      };
	  state.completeProposalId = null;
	}
	  
 },

  actions: {
    async generateAIResponseById({ commit }, { type, id, prompt }) {
      commit('SET_AI_LOADING_BY_ID', { type, id, status: true });

      try {
        const response = await proposalService.generateAiResponse({ prompt });
		var aiText=null;
		console.log('In store generateAIResponseById', prompt);
		console.log(response);
        if(response) aiText = response.message;
        // await new Promise((resolve) => setTimeout(resolve, 1000));
        // const aiText = `Sample AI Response for ${type} ${id}`;
        commit('SET_AI_RESPONSE_BY_ID', { type, id, response: aiText });

        return aiText;
      } catch (error) {
        console.error(error);
        throw error;
      } finally {
        commit('SET_AI_LOADING_BY_ID', { type, id, status: false });
      }
    },

    async generateAIResponse({ commit }, prompt) {
      commit('SET_LOADING', { aiGenerate: true });
      try {
        const response = await proposalService.generateAiResponse({ prompt });
		console.log('In store generateAIResponse', prompt);
		console.log(response);
		var aiText=null;
        if(response) aiText = response.message;
        // await new Promise((resolve) => setTimeout(resolve, 1000));
        // const aiText = `Sample AI Response`;
        commit('SET_AI_RESPONSE', aiText);
        return aiText;
      } catch (error) {
        console.error(error);
        throw error;
      } finally {
        commit('SET_LOADING', { aiGenerate: false });
      }
    },

    async fetchProjects({ commit }, { page = 1, limit = 5, search = '', marketSegmentId = null, from = null, to = null, teamMemberId = null }) {
      commit('SET_PROJECTS_LOADING', { memberId: teamMemberId, status: true })
      try {
        const response = await proposalService.fetchProjects(page, limit, search, marketSegmentId, from, to, teamMemberId)
		console.log('In fetchProjects');
		console.log(response);
		const {data,pagination}=response;
        commit('SET_PROJECTS', { data, pagination, page:pagination.page, memberId: teamMemberId })
        return {data,pagination};
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('SET_PROJECTS_LOADING', { memberId: teamMemberId, status: false })
      }
    },

    async fetchMembers({ commit }, { page = 1, limit = 10, search = '' }) {
      commit('SET_LOADING', { member: true })
      try {
        const response = await proposalService.fetchMembers(page, limit, search)
		console.log('In fetchMembers');
		console.log(response);
		const {data,pagination} = response;
        commit('SET_MEMBERS', { data, pagination, page:pagination.page })
        return {data,pagination};
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('SET_LOADING', { member: false })
      }
    },

    async fetchOpportunityById({ commit }, id) {
      commit('SET_LOADING', { opportunity: true })
      try {
        const response = await proposalService.fetchOpportunityById(id)
        commit('SET_SELECTED_OPPORTUNITY', response.data);
		console.log('In fetchOpportunityById response');
		console.log(response);
        return response.data;
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('SET_LOADING', { opportunity: false })
      }
    },

    async fetchMarketSegments({ commit }, { page = 1, limit = 10 }) {
      commit('SET_LOADING', { marketSegment: true })
      try {
        const response = await proposalService.fetchMarketSegments(page, limit)
		const {data,pagination} = response;
        commit('SET_MARKET_SEGMENTS', { data,pagination,page:pagination.page});
		console.log('In fetchMarketSegments response');
		console.log(response);
        return {data,pagination};
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('SET_LOADING', { marketSegment: false })
      }
    },

    async fetchUserData({ commit }) {
      commit('SET_LOADING', { userData: true })
      try {
        const response = await proposalService.fetchUserData()
        commit('SET_USER_DATA', response.data);
		console.log('In fetchUserData response');
		console.log(response);		
        return response.data
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('SET_LOADING', { userData: false })
      }
    },
	async initializeProposal({ commit },payload) {
	  const { opportunityId} = payload;
	  commit('RESET_PROPOSAL');
	  commit('SET_LOADING', { proposal: true })
	  try {
	  const response = await proposalService.fn_getProposal({opportunityId: opportunityId})
		console.log('initializeProposal response');
		console.log(response);
        if(response.recordData) {
			commit('SET_PROPOSAL', response.recordData.proposal);
			commit('SET_COMPLETEPROPOSALID', response.recordData.completeProposalId);
		}
		return response.recordData;
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('SET_LOADING', { proposal: false })
      }
    },
	
  async saveProposal({ commit }, payload) {
	 const { proposal } = payload;
	 try {
		const resp = await proposalService.fn_saveProposal(payload);
		if (resp.error) {
			 let msg = `Unable to save proposal Error: ${error.message || error}`;
			kbdpAlert.showErr(msg);
			} else {
				commit("SET_PROPOSAL", proposal);
				kbdpAlert.showOk('Proposal' + " was saved successfully.");
				}
		} catch (error) {
        console.error(error)
         let msg = `Unable to save proposal Error: ${error.message || error}`;
		kbdpAlert.showErr(msg);
      }
	
	},
    getPhotoURL({ state }, projectId) {
      const project = state.projects.data.find(p => p.projectId === projectId);
	  return project?.photoURL || null;
   },
   getResumeData({ state }, teamMemberId) {
    const member = state.members.data.find(m => m.teamMemberId === teamMemberId);
    return member?.resumeData || null;
   },
 async getProposalFile({ state }, proposalFileName) {
      try {
        const resp = await proposalService.fn_getProposalFile({fileName:proposalFileName});
		//const pdfData = await resp.arrayBuffer();
        return resp;
      } catch (error) {
        console.error(error)
        throw error;
	  }
	  return 
   },
   
async uploadProposalFile({ state }, params) {
  const { files, proposalFileId } = params;

  try {
    const resp = await proposalService.fn_uploadProposalFile(files, {proposalFileId:proposalFileId});
    if (!resp) throw new Error("Upload succeeded but filePath missing");
    return resp;
  } catch (error) {
    console.error("uploadProposalFile error:", error);
    throw error;
  }
},
async deleteProposalFile({ state }, params) {

  try {
    const resp = await proposalService.fn_deleteProposalFile(params);
    if (!resp) throw new Error("Delete succeeded but filePath missing");
    return resp;
  } catch (error) {
    console.error("uploadProposalFile error:", error);
    throw error;
  }
},

},
 modules: {
  }
})

